<div class="bloque-de-bienvenida-section">
    <div *ngIf="!showInputs" @fadeInOut class="container pt-5">
      <div class="color-opaco pb-5">
        <h2>Confirmación exitosa</h2>
        <small>Su usuario fue dado de alta exitosamente, a continuación se solicitará un nombre de usuario y clave</small>
      </div>
      <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-success" (click)="showInputs = true;">Continuar</button>
      </div>
    </div>
  
    <div *ngIf="showInputs" @fadeInOut class="container pt-5">
      <div class="color-opaco pb-5">
        <h2>Último paso</h2>
        <small>Complete con un usuario y repita la clave</small>
      </div>


      <div class="container d-flex justify-content-center">
        <div class="col-md-6">

            <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <!-- Campo de Nombre de Usuario -->
                <div class="form-group">
                    <label for="nombreUsuario">Nombre de Usuario</label>
                    <input
                    id="nombreUsuario"
                    type="text"
                    class="form-control"
                    formControlName="nombreUsuario"
                    />
                    <!-- Mensajes de error para Nombre de Usuario -->
                    <div *ngIf="form.get('nombreUsuario')?.touched && form.get('nombreUsuario')?.invalid">
                    <small *ngIf="form.get('nombreUsuario')?.errors?.required" class="text-danger">
                        El nombre de usuario es obligatorio.
                    </small>
                    <small *ngIf="form.get('nombreUsuario')?.errors?.caracteresEspeciales" class="text-danger">
                        El nombre de usuario no debe contener caracteres especiales.
                    </small>
                    <small *ngIf="form.get('nombreUsuario')?.errors?.nombreNoDisponible" class="text-danger">
                        El nombre de usuario no está disponible.
                    </small>
                    </div>
                </div>
        
                <!-- Campo de Contraseña -->
                <div class="form-group">
                    <label for="clave">Contraseña</label>
                    <input
                    id="clave"
                    type="password"
                    class="form-control"
                    formControlName="clave"
                    />
                    <!-- Mensajes de error para Contraseña -->
                    <div *ngIf="form.get('clave')?.touched && form.get('clave')?.invalid">
                    <small *ngIf="form.get('clave')?.errors?.required" class="text-danger">
                        La contraseña es obligatoria.
                    </small>
                    <small *ngIf="form.get('clave')?.errors?.passwordStrength" class="text-danger">
                        La contraseña debe contener al menos una letra mayúscula, una letra minúscula y un carácter especial.
                    </small>
                    </div>
                </div>
        
                <!-- Campo de Repetir Contraseña -->
                <div class="form-group">
                    <label for="RepitaClave">Repetir Contraseña</label>
                    <input
                    id="RepitaClave"
                    type="password"
                    class="form-control"
                    formControlName="RepitaClave"
                    />
                    <!-- Mensajes de error para Repetir Contraseña -->
                    <div *ngIf="form.get('RepitaClave')?.touched && form.get('RepitaClave')?.invalid">
                    <small *ngIf="form.get('RepitaClave')?.errors?.required" class="text-danger">
                        Por favor, repite la contraseña.
                    </small>
                    </div>
                </div>
        
                <!-- Mensaje de error para coincidencia de contraseñas -->
                <div *ngIf="form.errors?.passwordsMismatch && form.get('RepitaClave')?.touched">
                    <small class="text-danger">
                    Las contraseñas no coinciden.
                    </small>
                </div>
        
                <!-- Botón de Envío -->
                <button type="submit" class="btn btn-success mt-3">
                    Finalizar
                </button>
            </form>

        </div>
      </div>
      
      
      

    </div>
</div>
  